"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputConnectedWrapper = exports.InputContent = exports.InputContentContainer = exports.InputContainer = exports.InputRoot = void 0;

var _designLanguage = require("@doordash/design-language");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _constants = require("../constants");

var _utilities = require("@doordash/utilities");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FONT_STYLES = (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: ", "px;\n  line-height: ", "px;\n  letter-spacing: ", "ch;\n  font-weight: ", ";\n  @media (min-width: ", "px) {\n    font-size: ", "px;\n    line-height: ", "px;\n    letter-spacing: ", "ch;\n    font-weight: ", ";\n  }\n"])), function (props) {
  return props.mobileInputTextStyles.size;
}, function (props) {
  return props.mobileInputTextStyles.lineHeight;
}, function (props) {
  return props.mobileInputTextStyles.letterSpacing;
}, function (props) {
  return (0, _designLanguage.getResolvedWeightWithTheme)(props.theme, props.mobileInputTextStyles.weight);
}, _designLanguage.Breakpoints.Mobile + 1, function (props) {
  return props.desktopInputTextStyles.size;
}, function (props) {
  return props.desktopInputTextStyles.lineHeight;
}, function (props) {
  return props.desktopInputTextStyles.letterSpacing;
}, function (props) {
  return (0, _designLanguage.getResolvedWeightWithTheme)(props.theme, props.desktopInputTextStyles.weight);
});

var InputRoot = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  min-height: ", "px;\n"])), function (props) {
  return props.themeHeight;
});

exports.InputRoot = InputRoot;

var getErrorStyles = function getErrorStyles(props) {
  if (props.error) {
    return (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      background: ", ";\n      box-shadow: inset 0 0 0 ", "px\n        ", ";\n      color: ", ";\n    "])), props.theme.Colors.FieldsBackgroundError, props.theme.BorderWidth.FieldsError, props.theme.Colors.FieldsBorderError, props.theme.Colors.FieldsForegroundError);
  }

  return null;
};

var getBareStyles = function getBareStyles(props) {
  if (props.isBare) {
    return (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      box-shadow: none;\n      &:focus-within {\n        box-shadow: none;\n      }\n    "])));
  }

  return null;
};

var getDisabledStyles = function getDisabledStyles(props) {
  if (props.disabled) {
    return (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      background-color: ", ";\n      box-shadow: inset 0 0 0 ", "px\n        ", ";\n      color: ", ";\n      cursor: not-allowed;\n    "])), props.theme.Colors.FieldsBackgroundDisabled, props.theme.BorderWidth.FieldsDefault, props.theme.Colors.FieldsBorderDisabled, props.theme.Colors.FieldsForegroundDisabled);
  }

  return null;
};

var getPlaceholderStyles = function getPlaceholderStyles(props) {
  var placeholderColor = props.theme.Colors.FieldsForegroundPlaceholder;
  return (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    &::-webkit-input-placeholder {\n      /* WebKit, Blink, Edge */\n      color: ", ";\n    }\n    &:-moz-placeholder {\n      /* Mozilla Firefox 4 to 18 */\n      color: ", ";\n    }\n    &::-moz-placeholder {\n      /* Mozilla Firefox 19+ */\n      color: ", ";\n    }\n    &:-ms-input-placeholder {\n      /* Internet Explorer 10-11 */\n      color: ", ";\n    }\n    &::-ms-input-placeholder {\n      /* Microsoft Edge */\n      color: ", ";\n    }\n    &::placeholder {\n      /* Most modern browsers support this now. */\n      color: ", ";\n    }\n  "])), placeholderColor, placeholderColor, placeholderColor, placeholderColor, placeholderColor, placeholderColor);
};

var getPadding = function getPadding(props) {
  // Fields with the opt-in `isBare` prop set to `true`
  // will not have internal padding applied to the Field.
  if (props.isBare) {
    return '0px';
  } // Vertical (top/bottom) padding is applied when custom content is
  // displayed inside of the Field component. This can come via custom
  // content passed through in `renderAfterContent` or `renderBeforeContent`,
  // or from the native control applied to `textarea`s (applied via the
  // `isMultiline` prop)


  if (props.renderVerticalPadding && !props.hasDefaultRenderContent) {
    // Extra breathing room is applied on all sizes for the internal
    // padding in multiline, `textarea` Fields (when `isMultiline` is true)
    if (props.isAdjustableHeight) {
      return "".concat(props.size, "px ").concat(props.isRounded ? props.size * 2 : props.size, "px");
    } // Equal padding is applied on all sides for fields with custom render content.
    // If one of the two horizontal sides does NOT have custom render content
    // (as defined on lines 113-117), we increase the padding on that side to
    // achieve the best visual balance for the field & its wrapper.


    return "".concat(props.size / 2, "px ").concat(props.trailingRenderContent ? props.size / 2 : props.size, "px ").concat(props.size / 2, "px ").concat(props.leadingRenderContent ? props.size / 2 : props.size, "px");
  } // Certain types of Field components (like `PasswordField` and `SearchField`)
  // have render content built into them by default. In cases like this, the
  // field should not add vertical (top/bottom) padding because the Field has
  // been designed to include this leading and/or trailing content by default.
  // Fields with default render content will follow the same horizontal padding
  // logic as above (lines 127-129) to achieve the best visual balance.


  if (props.hasDefaultRenderContent) {
    // We increase the horizontal padding for `isRounded` Fields to ensure that
    // text input does not begin right at the curve of the pill-shaped container
    // (which looks strange and visually cramped)
    if (props.isRounded) {
      return "0px ".concat(props.trailingRenderContent ? props.size : props.size * 2, "px 0px ").concat(props.leadingRenderContent ? props.size : props.size * 2, "px");
    } // Non-rounded Fields with default render content will follow the same
    // padding logic as lines 130-134, with no vertical (top/bottom) padding


    return "0px ".concat(props.trailingRenderContent ? props.size / 2 : props.size, "px 0px ").concat(props.leadingRenderContent ? props.size / 2 : props.size, "px");
  } // The fallback behavior for any Fields that don't meet the above criteria
  // is to only contain horizontal padding aligned with the Field's `size`
  // prop. This ensures that the default height for the Field is equal to the
  // size defined in the theme.


  return "0px ".concat(props.size, "px");
};

var InputContainer = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", "\n  font-family: ", ";\n  color: ", ";\n  display: flex;\n  align-items: center;\n  width: 100%;\n  border-radius: ", "px;\n  z-index: 1;\n  padding: ", ";\n\n  border: none;\n  box-shadow: inset 0 0 0 ", "px\n    ", ";\n  background-color: ", ";\n\n  &:focus-within {\n    background-color: ", ";\n    ", ";\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), FONT_STYLES, function (props) {
  return (0, _designLanguage.themedFontFamily)(props.theme.FontFamily);
}, function (props) {
  return props.theme.Colors.FieldsForegroundInactive;
}, function (props) {
  return props.isRounded ? props.theme.Size[_constants.SizeSemantics[props.size]] : props.theme.BorderRadius.FieldsInputDefault;
}, getPadding, function (props) {
  return props.theme.BorderWidth.FieldsDefault;
}, function (props) {
  return props.theme.Colors.FieldsBorderInactive;
}, function (props) {
  return props.theme.Colors.FieldsBackgroundInactive;
}, function (props) {
  return props.theme.Colors.FieldsBackgroundActive;
}, function (props) {
  return (0, _designLanguage.getFocusStyles)({
    focusColor: props.theme.Colors.FieldsBorderActive,
    shouldUseFocusRing: false,
    focusWidth: props.theme.BorderWidth.FieldsFocus
  });
}, function (props) {
  return !props.roundedRight && (0, _styledComponents.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      border-top-right-radius: ", ";\n      border-bottom-right-radius: ", ";\n    "])), props.theme.BorderRadius.None, props.theme.BorderRadius.None);
}, function (props) {
  return !props.roundedLeft && (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      border-top-left-radius: ", ";\n      border-bottom-left-radius: ", ";\n    "])), props.theme.BorderRadius.None, props.theme.BorderRadius.None);
}, getErrorStyles, getBareStyles, getDisabledStyles);

exports.InputContainer = InputContainer;

var InputContentContainer = _styledComponents["default"].div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  background: inherit;\n  max-width: 98%;\n  margin: 0 ", " 0 auto;\n"])), function (props) {
  return props.hasTrailingRenderContent ? "".concat(_designLanguage.Spacing.XxSmall, "px") : 'auto';
});

exports.InputContentContainer = InputContentContainer;

var getDisabledContentStyles = function getDisabledContentStyles(props) {
  if (props.disabled) {
    return (0, _styledComponents.css)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n      cursor: not-allowed;\n    "])));
  }

  return null;
};

var getTextStyles = function getTextStyles(props) {
  if (props.type === 'text') {
    return (0, _styledComponents.css)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n      min-height: ", "px;\n      resize: ", ";\n    "])), (props.numberOfLines || 1) * 24, props.isResizeable ? 'vertical' : 'none');
  }

  return null;
};

var getSelectStyles = function getSelectStyles(props) {
  if (props.tag === 'select') {
    return (0, _styledComponents.css)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n      height: 24px;\n      appearance: none;\n      margin-right: -24px;\n      /*\n       * When set as a select in IE, hide\n       * the default browser down caret since \n       * we provide our own implementation\n       */\n      &::-ms-expand {\n        display: none;\n      }\n    "])));
  }

  return null;
};

var InputContent = (0, _utilities.withDynamicTag)(_styledComponents["default"].input(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  ", "\n  font-family: ", ";\n  width: 100%;\n  border: none;\n  outline: none;\n  flex: 1 1 100%;\n  display: flex;\n  background: transparent;\n  /*\n   * Make sure default element appearance\n   * is not applied so that we can provide\n   * our own styling\n   */\n  appearance: none;\n  /*\n   * Normalize margin and padding to remove size\n   * differences between browsers of the component\n   */\n  margin: 0;\n  padding: 0;\n  ", "\n  ", "\n  ", ";\n  ", ";\n"])), FONT_STYLES, function (props) {
  return (0, _designLanguage.themedFontFamily)(props.theme.Typography.FontFamily);
}, getDisabledContentStyles, getTextStyles, getSelectStyles, getPlaceholderStyles));
exports.InputContent = InputContent;

var getBorderRadiusForConnectedWrapper = function getBorderRadiusForConnectedWrapper(props) {
  var borderRadius = props.isRounded || props.theme.Shape.Field === _designLanguage.Shape.Pill ? props.size * 2 : props.theme.BorderRadius.FieldsInputConnectedWrapperDefault;

  if (props.side === 'left') {
    return "".concat(borderRadius, "px 0 0 ").concat(borderRadius, "px");
  }

  return "0 ".concat(borderRadius, "px ").concat(borderRadius, "px 0");
};

var InputConnectedWrapper = _styledComponents["default"].div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  overflow: hidden;\n  border-radius: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-shrink: 0;\n\n  > * {\n    flex: 1 0 auto;\n  }\n\n  &:focus-within {\n    ", ";\n  }\n"])), getBorderRadiusForConnectedWrapper, function (props) {
  return (0, _designLanguage.getFocusStyles)({
    shouldUseFocusRing: false,
    focusWidth: props.theme.BorderWidth.FieldsFocus
  });
});

exports.InputConnectedWrapper = InputConnectedWrapper;